import { render, staticRenderFns } from "./laborNew.vue?vue&type=template&id=72632513&"
import script from "./laborNew.vue?vue&type=script&lang=js&"
export * from "./laborNew.vue?vue&type=script&lang=js&"
import style0 from "./laborNew.vue?vue&type=style&index=0&id=72632513&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports